// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2j-3";
export var dialog = "_2j-0";
export var divClassnameSwatch = "_2j-8";
export var flexSwatch = "_2j-4";
export var header = "_2j-1";
export var styleAttributeSwatch = "_2j-7";
export var swatch = "_2j-2";
export var textHeaderSwatch = "_2j-5";
export var webSwatch = "_2j-6";